import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
    selector: 'app-bank-customer-operations',
    templateUrl: './bank-customer-operations.component.html',
    styleUrls: ['./bank-customer-operations.component.scss']
})
export class BankCustomerOperationsComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() page_data: any;
	@Input() page_operation_type: any;

	@Output() bankCustomerOperationsClosed = new EventEmitter<any>();
	@Output() bankCustomerOperationsUpdated = new EventEmitter<any>();

	current_date: any = new Date();
	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		this.getGenders();
		this.getStatus();
		this.getStates();
		this.getRegion();
		this.getProductStatus();

		this.getDataTypeList();
		this.getBusinessPlan();
		setTimeout(() => {
			this.openClientOperationModal();
		}, 200);
	}

	region_list: any = [];
	getRegion() {
		const financial_institution = this.user_details.financial_institution;

		this.commonService.getData('/region?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.region_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_status_list: any = [];
	getProductStatus() {
		this.commonService.getData('/clientProductStatus?no_page=true/').subscribe(
			(res: any) => {
				this.product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatus() {
		this.commonService.getData('/clientStatus?no_page=true/').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	states_list: any = [];
	getStates() {
		this.commonService.getData('/state?no_page=true/').subscribe(
			(res: any) => {
				this.states_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	data_type_list: any = [];
	getDataTypeList() {
		this.commonService.getData('/datatype?no_page=true/').subscribe(
			(res: any) => {
				this.data_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	data_type_values_list: any = [];
	getDataTypeValues(value) {
		if (value == 4) {
			this.data_type_values_list = [];
		} else if (value == 5) {
			this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		} else if (value == 6) {
			this.commonService.getData('/financialinstitution?no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		} else {
			this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
				(res: any) => {
					this.data_type_values_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				}
			);
		}
	}

	business_plan_list: any = [];
	getBusinessPlan() {
		const financial_institution = this.user_details.financial_institution;
		this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution).subscribe(
			(res: any) => {
				this.business_plan_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('pageOperationsModal') pageOperationsModal: TemplateRef<any>;
  	private pageOperationsModalRef: MatDialogRef<TemplateRef<any>>;
	openClientOperationModal() {
		if (this.page_operation_type == 'Add') {
			this.page_data = JSON.parse(JSON.stringify(this.ideal_page_data));
			this.page_data.status = 'Active';

		} else {
			this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'MM-dd-yyyy');
			this.page_data.member_since = this.datePipe.transform(this.page_data.member_since, 'MM-dd-yyyy');

			if ( this.page_data.last_date_of_contact != "" &&  this.page_data.last_date_of_contact != null) {
				this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'MM-dd-yyyy');
			}

			this.getDataTypeValues(this.page_data.source_type_id);

		}

		this.pageOperationsModalRef = this.dialog.open(this.pageOperationsModal, { disableClose: true } );
		this.pageOperationsModalRef.afterClosed().subscribe((result) => {
			this.closeClientOperationModal();
		});
	}

	closeClientOperationModal() {
		this.bankCustomerOperationsClosed.emit("Closed");
		this.pageOperationsModalRef.close();
	}

	client_operation_stepper: any = 1;
	navigateBack() {
		this.client_operation_stepper = this.client_operation_stepper - 1;
	}

	product_error: boolean = false;
	validateClientDetails() {
		if (this.client_operation_stepper == 1) {
			const fields = [
				{ key: "prospect_id", type: "text" },
				{ key: "member_since", type: "date" },
				{ key: "first_name", type: "text" },
				{ key: "last_name", type: "text" },
				{ key: "email", type: "email" },
				{ key: "birth_date", type: "date" },
				{ key: "individual_income_in_dollars_actual", type: "number" },
				{ key: "status_id", type: "text" },
				{ key: "state_id", type: "text" },
			];

			if (this.validateClientIndividualSection(fields)) {
				if (this.page_data.source_type_id == 2) {
					if (this.page_data.source != "" && this.page_data.source != null) {
						this.page_data_errors.source = false;
					} else {
						this.page_data_errors.source = true;
					}
					this.page_data_errors.source_id = false;
				} else if (this.page_data.source_type_id != 4) {
					if (this.page_data.source_id != "" && this.page_data.source_id != null) {
						this.page_data_errors.source_id = false;
					} else {
						this.page_data_errors.source_id = true;
					}

					this.page_data_errors.source = false;
				}

				if (
					this.page_data_errors.source == false &&
					this.page_data_errors.source_id == false
				) {
					this.client_operation_stepper = this.client_operation_stepper + 1;
				}
			}

		} else if (this.client_operation_stepper == 2) {
			const fields = [];

			if (this.validateClientIndividualSection(fields)) {
				this.client_operation_stepper = this.client_operation_stepper + 1;
			}
		} else if (this.client_operation_stepper == 3) {
			const fields = [
				// { key: "business_plan_id", type: "text"}
			];

			if (this.validateClientIndividualSection(fields)) {
				this.client_operation_stepper = this.client_operation_stepper + 1;
			}
		} else if (this.client_operation_stepper == 4) {
			if (this.client_product_operation_type == "") {
                this.saveClientInformation();
            }
		}
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	validEmail(email) {
		if (
			email != '' &&
			/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		) {
			return true;
		} else {
			return false;
		}
	}

	global_error: boolean = false;
	validateClientIndividualSection(fields) {
		if (fields.length > 0) {
			// let error: boolean = false;
			this.global_error = false;
			for (let index = 0; index < fields.length; index++) {
				if (fields[index].type == "text" || fields[index].type == "number" || fields[index].type == "date") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "email") {
					if (this.page_data[fields[index]["key"]] != "" && this.page_data[fields[index]["key"]] != null && this.validEmail(this.page_data[fields[index]["key"]])) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				} else if (fields[index].type == "boolean") {
					if (this.page_data[fields[index]["key"]] == true || this.page_data[fields[index]["key"]] == false) {
						this.page_data_errors[fields[index]["key"]] = false;
					} else {
						this.page_data_errors[fields[index]["key"]] = true;
						// error = true;
						this.global_error = true;
					}
				}
			}

			// if (error == true) {
			// 	return false;
			// } else {
			// 	return true;
			// }

			if (this.global_error == true) {
				return false;
			} else {
				return true;
			}

		} else {
			this.global_error = false
			return true;
		}
	}

	saveClientInformation() {
		this.page_data.birth_date = this.datePipe.transform(this.page_data.birth_date, 'yyyy-MM-dd');
		this.page_data.member_since = this.datePipe.transform(this.page_data.member_since, 'yyyy-MM-dd');
		this.page_data.last_date_of_contact = this.datePipe.transform(this.page_data.last_date_of_contact, 'yyyy-MM-dd');

		if (this.page_data.net_worth_actual) {
			this.page_data.net_worth = this.page_data.net_worth_actual;
		}

		if (this.page_data.client_wallet_share_from_lpl_actual) {
			this.page_data.client_wallet_share_from_lpl = this.page_data.client_wallet_share_from_lpl_actual;
		}

		if (this.page_data.client_net_worth_from_lpl_actual) {
			this.page_data.client_net_worth_from_lpl = this.page_data.client_net_worth_from_lpl_actual;
		}

		if (this.page_data.household_income_in_dollars_actual) {
			this.page_data.household_income_in_dollars = this.page_data.household_income_in_dollars_actual;
		}

		if (this.page_data.market_value_of_home_in_dollars_actual) {
			this.page_data.market_value_of_home_in_dollars = this.page_data.market_value_of_home_in_dollars_actual;
		}

		if (this.page_data.home_equity_available_for_mortgage_in_dollars_actual) {
			this.page_data.home_equity_available_for_mortgage_in_dollars = this.page_data.home_equity_available_for_mortgage_in_dollars_actual;
		}

		if (this.page_data.individual_income_in_dollars_actual) {
			this.page_data.individual_income_in_dollars = this.page_data.individual_income_in_dollars_actual;
		}

		if (this.page_data.total_networth_actual) {
			this.page_data.total_networth = this.page_data.total_networth_actual;
		}

		if (this.page_operation_type == 'Add') {
			this.commonService.postData('/prospect/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Bank Customer has been added successfully.');
					this.bankCustomerOperationsUpdated.emit("Added");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
			this.commonService.updateData('/prospect/' + this.page_data.id + '/', this.page_data).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Bank Customer has been updated successfully.');
					this.bankCustomerOperationsUpdated.emit("Updated");

					this.pageOperationsModalRef.close();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			  );
		}
	}


	ideal_page_data: any = {
		prospect_id: "",
		member_since: "",
		first_name: "",
		last_name: "",
		telephone_number: "",
		email: "",
		gender_id: "",
		birth_date: "",
		education: "",
		occupation: "",
		years_experience: "",
		marital_status: "",
		individual_income_in_dollars_actual: "",
		status_id: "",
		address_line_1: "",
		address_line_2: "",
		city: "",
		state_id: "",
		region_id: "",
		zip_code: "",
		homeowner_or_renter: "",
		years_in_residence: "",
		address_2_line_1: "",
		address_2_line_2: "",
		address_2_city: "",
		address_2_state_id: "",
		address_2_region_id: "",
		address_2_zip_code: "",
		address_2_years_in_residence: "",
		address_2_homeowner_or_renter: "",
		address_3_line_1: "",
		address_3_line_2: "",
		address_3_city: "",
		address_3_state_id: "",
		address_3_region_id: "",
		address_3_zip_code: "",
		address_3_years_in_residence: "",
		address_3_homeowner_or_renter: "",
		household_id: "",
		is_primary_contact: false,
		adults_in_household: "",
		children_in_household: "",
		household_income_in_dollars_actual: "",
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: "",
		economic_stability: "",
		vehicle_type: "",
		vehicle_count: "",
		property_type: "",
		home_equity_available_for_mortgage_in_dollars_actual: "",
		loan_to_value_in_percentage: "",
		market_value_of_home_in_dollars_actual: "",
		client_wallet_share_from_lpl_actual: "",
		client_net_worth_from_lpl_actual: "",
		net_worth_actual: "",
		total_networth_actual: "",
		source: "",
		segment: "",
		source_type_id: "",
		source_id: "",
		last_date_of_contact: "",
		business_plan_id: "",
		linkedin_url: "",
		twitter_url: "",
		facebook_url: "",
		current_assests_actual: "",
		liabilities_actual: "",
		expenses_actual: "",
		other_investment_actual: "",
		products: []
	};

	page_data_errors: any = {
		prospect_id: false,
		member_since: false,
		first_name: false,
		last_name: false,
		telephone_number: false,
		email: false,
		gender_id: false,
		birth_date: false,
		education: false,
		occupation: false,
		years_experience: false,
		marital_status: false,
		individual_income_in_dollars_actual: false,
		status_id: false,
		address_line_1: false,
		address_line_2: false,
		city: false,
		state_id: false,
		region_id: false,
		zip_code: false,
		homeowner_or_renter: false,
		years_in_residence: false,
		address_2_line_1: false,
		address_2_line_2: false,
		address_2_city: false,
		address_2_state_id: false,
		address_2_region_id: false,
		address_2_zip_code: false,
		address_2_years_in_residence: false,
		address_2_homeowner_or_renter: false,
		address_3_line_1: false,
		address_3_line_2: false,
		address_3_city: false,
		address_3_state_id: false,
		address_3_region_id: false,
		address_3_zip_code: false,
		address_3_years_in_residence: false,
		address_3_homeowner_or_renter: false,
		household_id: false,
		is_primary_contact: false,
		adults_in_household: false,
		children_in_household: false,
		household_income_in_dollars_actual: false,
		real_estate_investor: false,
		premium_credit_card_holder: false,
		heavy_transactor: false,
		economic_stability: false,
		vehicle_type: false,
		vehicle_count: false,
		property_type: false,
		home_equity_available_for_mortgage_in_dollars_actual: false,
		loan_to_value_in_percentage: false,
		market_value_of_home_in_dollars_actual: false,
		client_wallet_share_from_lpl_actual: false,
		client_net_worth_from_lpl_actual: false,
		net_worth_actual: false,
		total_networth_actual: false,
		source: false,
		lead_assigned_date: false,
		segment: false,
		source_type_id: false,
		source_id: false,
		last_date_of_contact: false,
		business_plan_id: false,
		linkedin_url: false,
		twitter_url: false,
		facebook_url: false,
		current_assests_actual: false,
		liabilities_actual: false,
		expenses_actual: false,
		other_investment_actual: false,
		products: false
	};

	client_product_details: any = {
		loan_id: "",
		product: "",
		loan_status: "",
		issue_date: "",
		interest_rate: "",
		loan_amount: "",
	};
	client_product_operation_type: any = "";
	client_product_operation_index: any = null;
	client_product_details_errors: any = {
		loan_id: false,
		product: false,
		loan_status: false,
		issue_date: false,
		interest_rate: false,
		loan_amount: false,
	};

	clientProductOperations(data, type, index) {
		this.client_product_details = JSON.parse(JSON.stringify(data));
		this.client_product_operation_type = type;
		this.client_product_operation_index = index;

		if (this.client_product_details.issue_date == "" || this.client_product_details.issue_date == null) {
			this.client_product_details.issue_date = new Date();
		} else {
			this.client_product_details.issue_date = this.datePipe.transform(this.client_product_details.issue_date, 'MM-dd-yyyy');
		}

	}

	validateClientProduct() {
		if (
			this.client_product_details.product_name != "" && this.client_product_details.product_name != null
		) {
			this.client_product_details_errors.product_name = false;
		} else {
			this.client_product_details_errors.product_name = true;
		}

		if (
			this.client_product_details.loan_id != "" && this.client_product_details.loan_id != null
		) {
			this.client_product_details_errors.loan_id = false;
		} else {
			this.client_product_details_errors.loan_id = true;
		}

		if (
			this.client_product_details.loan_status != "" && this.client_product_details.loan_status != null
		) {
			this.client_product_details_errors.loan_status = false;
		} else {
			this.client_product_details_errors.loan_status = true;
		}

		if (
			this.client_product_details.issue_date != "" && this.client_product_details.issue_date != null
		) {
			this.client_product_details_errors.issue_date = false;
		} else {
			this.client_product_details_errors.issue_date = true;
		}

		if (
			this.client_product_details.interest_rate != "" && this.client_product_details.interest_rate != null
		) {
			this.client_product_details_errors.interest_rate = false;
		} else {
			this.client_product_details_errors.interest_rate = true;
		}

		if (
			this.client_product_details.loan_amount != "" && this.client_product_details.loan_amount != null
		) {
			this.client_product_details_errors.loan_amount = false;
		} else {
			this.client_product_details_errors.loan_amount = true;
		}

		if (
			this.client_product_details_errors.product_name == false &&
			this.client_product_details_errors.loan_id == false &&
			this.client_product_details_errors.loan_status == false &&
			this.client_product_details_errors.issue_date == false &&
			this.client_product_details_errors.interest_rate == false &&
			this.client_product_details_errors.loan_amount == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveClientProduct() {
		if (this.validateClientProduct()) {
			this.client_product_details.issue_date = this.datePipe.transform(this.client_product_details.issue_date, 'yyyy-MM-dd');
			if (this.client_product_operation_type == "Add") {
				this.page_data.products.push(this.client_product_details);
				this.cancelClientProduct();
			} else {
				if (this.client_product_details.id) {
					const index = this.page_data.products.findIndex((x) => x.id == this.client_product_details.id);
					this.page_data.products.splice(index, 1, this.client_product_details);
					this.cancelClientProduct();
				} else  {
					this.page_data.products.splice(this.client_product_operation_index, 1, this.client_product_details);
					this.cancelClientProduct();
				}
			}
		}

	}

	cancelClientProduct() {
		this.client_product_details = {
			loan_id: "",
			product_name: "",
			loan_status: "",
			issue_date: "",
			interest_rate: "",
			start_date: "",
			loan_amount: "",
		};
		this.client_product_operation_type = "";
		this.client_product_operation_index = null;
		this.client_product_details_errors = {
			loan_id: false,
			product_name: false,
			loan_status: false,
			issue_date: false,
			interest_rate: false,
			start_date: false,
			loan_amount: false,
		};
	}

	@ViewChild('deleteClientProductModal') deleteClientProductModal: TemplateRef<any>;
	private deleteClientProductModalRef: MatDialogRef<TemplateRef<any>>;
	deleteClientProduct(data, index) {
		this.client_product_details = JSON.parse(JSON.stringify(data));
		this.client_product_operation_index = JSON.parse(JSON.stringify(index));
		this.deleteClientProductModalRef = this.dialog.open(this.deleteClientProductModal, { disableClose: true });
		this.deleteClientProductModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteClientProduct();
		});
	}

	closeDeleteClientProduct() {
		this.cancelClientProduct();
		this.deleteClientProductModalRef.close();
	}

	deleteClientProductDetails() {
		if (this.client_product_details.id) {
			const index = this.page_data.products.findIndex((x) => x.id == this.client_product_details.id);
			this.page_data.products.splice(index, 1);
			this.closeDeleteClientProduct();
		} else {
			this.page_data.products.splice(this.client_product_operation_index, 1);
			this.closeDeleteClientProduct();
		}
	}

	@ViewChild('householdLookupModal') householdLookupModal: TemplateRef<any>;
	private householdLookupModalRef: MatDialogRef<TemplateRef<any>>;
	openHouseholdLookupModal() {
		this.householdLookupModalRef = this.dialog.open(this.householdLookupModal, { disableClose: true });
		this.householdLookupModalRef.afterClosed().subscribe((result) => {
			this.closeHouseholdLookupModal();
		});
	}

	closeHouseholdLookupModal() {
		this.householdLookupModalRef.close();
		this.household_list = [];
		this.household_search_key = "";
	}

	changePrimaryContact() {
		if (this.page_data.is_primary_contact == true) {
			this.generateHouseholdID();
		}
	}



	generated_household_id: any = "";
	generateHouseholdID() {
		// if (this.page_data.household_id == "" || this.page_data.household_id == null) {
		// 	if (this.generated_household_id == "" || this.generated_household_id != null) {
		// 		this.commonService.getData('/generatehouseholdid/').subscribe(
		// 			(res: any) => {
		// 				this.generated_household_id = res;
		// 				this.page_data.household_id = this.generated_household_id;
		// 			},
		// 			(err) => {
		// 				this.commonService.showToast('error', err.error);
		// 			},
		// 		);
		// 	}
		// }

		if (this.page_data.household_id == "" || this.page_data.household_id == null) {
			this.commonService.getData('/generatehouseholdid/').subscribe(
				(res: any) => {
					this.generated_household_id = res;
					this.page_data.household_id = this.generated_household_id;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	household_search_key: any = "";
	lookUpHouseHold() {
		this.household_search_key = "";
		this.openHouseholdLookupModal();
	}

	household_list: any = [];
	searchHousehold() {
		this.commonService.getData('/gethouseholdid/?search=' + this.household_search_key).subscribe(
			(res: any) => {
				this.household_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	copy(data) {
		this.page_data.household_id = data.household_id;
		this.page_data.household_primary_contact_name = data.household_primary_contact_name;
		this.closeHouseholdLookupModal();
	}

}
